import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { AngularMaterialModule } from 'src/app/material.module';
import { RoleComponent } from './role.component';
import { ProcessModule } from '../process/process.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export const baseRoutes: Routes = [
  {
    path: '',
    component: RoleComponent,
    data: {
      title: 'Role'
    }
  }
];

@NgModule({
  imports: [
    CommonModule,AngularMaterialModule,FormsModule,ReactiveFormsModule,
    RouterModule.forChild(baseRoutes),ProcessModule
  ],
  declarations: [RoleComponent],
  exports:[RoleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RoleMasterModule { }
